import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TranscricaoListaItem } from '../../../../../interfaces/entities/Transcricao/TranscricaoListaItem';
import { buildTranscricaoConsultaPath } from '../../../../../interfaces/entities/Transcricao/transcricaoResourceToken';
import { recuperarListaTranscricao } from '../../../../../services/TranscricaoBeneficiarioService';
import { scrollTo } from '../../../../../utils/ScrollUtil';
import { deveExibirTranscricaoNaLista } from '../../transcricaoStatusUtils';
import {
  getTranscricaoCodStatus,
  getTranscricaoDataSolicitacaoTimestamp,
  getTranscricaoItemId,
} from '../../utils/transcricaoListaUtils';

const PAGE_SIZE = 10;

export const useConsultarTranscricaoLista = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [lista, setLista] = useState<TranscricaoListaItem[]>([]);
  const [erro, setErro] = useState<string | null>(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const carregar = async () => {
      setLoading(true);
      setErro(null);
      const resultado = await recuperarListaTranscricao();
      if (!resultado.ok) {
        setErro(resultado.message);
        setLista([]);
      } else {
        setLista(resultado.data);
      }
      setLoading(false);
    };
    void carregar();
  }, []);

  const listaVisivel = useMemo(
    () =>
      lista
        .filter((item) => deveExibirTranscricaoNaLista(getTranscricaoCodStatus(item)))
        .sort(
          (a, b) =>
            getTranscricaoDataSolicitacaoTimestamp(b) - getTranscricaoDataSolicitacaoTimestamp(a),
        ),
    [lista],
  );

  const totalPages = Math.ceil(listaVisivel.length / PAGE_SIZE);
  const paginatedLista = listaVisivel.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    scrollTo('consultar-transcricao-title');
  };

  const handleVerDetalhes = (item: TranscricaoListaItem) => {
    const id = getTranscricaoItemId(item);
    if (!id) return;
    navigate(buildTranscricaoConsultaPath(id), { state: { listaItem: item } });
  };

  return {
    loading,
    erro,
    listaVisivel,
    paginatedLista,
    page,
    totalPages,
    pageSize: PAGE_SIZE,
    handlePageChange,
    handleVerDetalhes,
  };
};
